import React, { useState } from 'react'
import LightAddIcon from '../../assets/icons/LightAddIcon'
import ViewSecurity from './ViewSecurity'
import CreateGuestModal from '../../components/Modal/Security/CreateGuestModal'
import SecurityService from '../../api/security'
import { AddGuestRes } from '../../interfaces/security'
import CopyCodeModal from '../../components/Modal/Security/CopyCodeModal'
import Metadata from '../../components/Metadata'
import PageWrapper from '../../components/PageWrapper'
const Security = () => {
  const [currentView, setCurrentView] = React.useState('')
  const [loading, setLoading] = React.useState(true)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [isCodeModalOpen, setIsCodeModalOpen] = useState<boolean>(false)
  const [guestInfo, setGuestInfo] = useState<AddGuestRes | null>(null);
  const [currentPage, setCurrentPage] = React.useState(1)
  const isActiveView = (view: string) => {
    return view === currentView
  }

  const handleViewSelect = (view: string, queries?: Record<string, string>) => {
    if (isActiveView(view)) {
      return
    }
    let queryArr = [`active=${view}`]
    for (let key in queries) {
      queryArr.push(`${key}=${queries[key]}`)
    }
    window.history.replaceState(null, '', `?${queryArr.join('&')}`)
    setCurrentView(view)
  }
  const {
  data,
  error,
  isLoading,
  mutate,
} = SecurityService.useGetGuestList({
  page: currentPage,
});

console.log(data);
console.log(error);
  React.useEffect(() => {
    const search = window.location.search.substring(1)
    const searchObj = search
      ? JSON.parse(
        `{"${search.replace(/&/g, '","').replace(/=/g, '":"')}"}`,
        function (key, value) {
          return key === '' ? value : decodeURIComponent(value)
        }
      )
      : { active: 'view' }
    setLoading(false)

    setCurrentView(searchObj.active)
  }, [])

  React.useEffect(() => { }, [currentView])


  const securityMetadata = {
    title: 'Security - Safelto',
    description: 'Manage guest access, view security logs, and generate access codes for your estate. Secure and efficient guest management system.',
    keywords: ['security', 'guest management', 'access control', 'security logs', 'property security'],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com/security',
    type: 'website' as 'website'
  }

  return (
    <PageWrapper title="Security" description="View all logs and generated code">
      <Metadata {...securityMetadata} />
      {isModalOpen ? (
        <CreateGuestModal open={isModalOpen} setIsOpen={setIsModalOpen} mutate={() => mutate()}   onGuestCreated={(guest: AddGuestRes) => {
          setGuestInfo(guest);     
          setIsCodeModalOpen(true);    
        }}

        />
      ) : isCodeModalOpen ? (
        <CopyCodeModal open = {isCodeModalOpen} setIsOpen={setIsCodeModalOpen} guestInfo={guestInfo}/>
      ): null}

      <div className=" flex flex-wrap">
        <button onClick={() => setIsModalOpen(true)} className="flex space-x-5 justify-center items-center p-4 bg-[#F8F9FA] rounded-lg">
          <div className="bg-black p-2.5 rounded-lg">
            <LightAddIcon />
          </div>
          <p className="text-black font-medium">Add new guest</p>
        </button>
      </div>

      <div>
        <ViewSecurity handleViewSelect={handleViewSelect}
          setCurrentPage={setCurrentPage} />
      </div>
    </PageWrapper>
  )
}

export default Security
